import { render, staticRenderFns } from "./BillFlowMinute.vue?vue&type=template&id=be021794&scoped=true"
import script from "./BillFlowMinute.vue?vue&type=script&lang=js"
export * from "./BillFlowMinute.vue?vue&type=script&lang=js"
import style0 from "./BillFlowMinute.vue?vue&type=style&index=0&id=be021794&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be021794",
  null
  
)

export default component.exports